import React from 'react';

export const Cities = React.lazy(() => import('./Cities'));
